import React from 'react'
import styled from '@emotion/styled'
import { KambiHistoryCoupon } from '@mobi/api-types/kambi'
import { colors, font, radius, spacing } from '@mobi/component-library/Foundations'

export const OutcomeResult: React.FC<{
  outcome: KambiHistoryCoupon['outcomes'][0]
  attachToSelectionInfo: boolean
}> = ({ outcome, attachToSelectionInfo }) => {
  const { settledInfo } = outcome
  if (!settledInfo) return null

  const score = settledInfo.result.score
  const label = getLabel(outcome)

  if (!score && !label) return null
  const resultText = [score, label].filter(Boolean)

  return (
    <WrapperStyled
      style={
        attachToSelectionInfo
          ? {
              borderTop: `1px solid ${colors.neutral[300]}`,
              borderBottomLeftRadius: radius.md,
              borderBottomRightRadius: radius.md,
            }
          : { borderRadius: radius.md }
      }
    >
      Result:<span>{resultText}</span>
    </WrapperStyled>
  )
}

// ============
// Local helper
// ============
const outcomeTypesUseCorrect = ['over', 'under', 'yes', 'no']

function getLabel(outcome: KambiHistoryCoupon['outcomes'][0]) {
  const label = outcome.settledInfo?.result.correct[0]
  const lowerLabel = label && label.toLowerCase()

  if (lowerLabel && outcomeTypesUseCorrect.some(o => lowerLabel.includes(o))) return label
  return null
}

// =======
// Styles
// =======

const WrapperStyled = styled.span({
  color: colors.neutral[900],
  textAlign: 'left',
  fontSize: font.size.md.fontSize,
  fontWeight: font.weight.medium,
  lineHeight: font.size.md.lineHeight,
  padding: spacing.sm,
  background: colors.neutral[200],
  display: 'flex',
  gap: spacing.smx2,

  '> span': {
    color: colors.neutral[800],
    fontWeight: font.weight.regular,
    lineHeight: font.size.md.lineHeight,
  },
})
